export default {
  name: 'es-mycard-send-list',
  data: () => ({
    shopList: [],
    sendUserList: [],
    selectShopId: '',
    loadError: false
  }),
  created: function () {
    this.selectShopId = localStorage.shop_id
    this.getShopList()
    this.shopChange()
  },
  computed: {
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    getUserImage () {
      return imagePath => {
        if (imagePath) {
          return `${imagePath}?token=${localStorage.access_token}&timestamp=${this.timeStamp}`
        }
        return require('../images/img_profile.png')
      }
    }
  },
  methods: {
    goEsMycardSelectDesign () {
      this.$router.push({ path: '/select_design'})
    },
    goEsMyCardNew (sendUserInfo) {
      const card = {
        get_user_id: sendUserInfo.id,
        get_user_image: sendUserInfo.attributes['profile-path'],
        get_user_shop_name: sendUserInfo.attributes['shop-name'],
        get_user_name: sendUserInfo.attributes['user-name'] + sendUserInfo.attributes['user-firstname'],
        background_path: this.$router.history.current.query.background_path,
        character_1_folder_path: this.$router.history.current.query.character_1_folder_path,
        character_1_path: this.$router.history.current.query.character_1_path,
        character_2_path: this.$router.history.current.query.character_2_path
      }
      // 配列をSessionStorageに保持
      sessionStorage.setItem('es_mycard', JSON.stringify(card))
      // カード作成画面へ遷移
      this.$router.push({ path: '/es_mycard/new'})
    },
    async getShopList () {
      // 旧実装はエラーを握りつぶしてundefinedのまま filter を呼んでいたため、
      // 通信に失敗すると例外で処理が止まり、店舗一覧が表示されないままになっていた
      let retShopList = null
      try {
        retShopList = await this.$store.dispatch('MYCARD_GET_SHOPS')
      } catch (err) {
        console.error(err)
        this.handleLoadError(true)
        return
      }
      if (!retShopList) {
        this.handleLoadError(true)
        return
      }
      // 表示しない店舗を取り除く
      this.shopList = retShopList.filter(shop => {
        if (shop.id !== 4 && shop.id !== 730 && shop.id !== 750 && shop.id !== 800) {
          return shop
        }
      })
    },
    handleLoadError (backToSelectDesign) {
      // 白画面のままにせず、必ず原因を伝える
      if (this.loadError) {
        return
      }
      this.loadError = true
      alert('通信エラーが発生したニャン。もう一度お試しくださいニャン。')
      if (backToSelectDesign) {
        // 店舗一覧が取れないと画面自体が使えないため、デザイン選択画面に戻す
        this.$router.push({ path: '/select_design' })
      } else {
        // 店舗の切り替えに失敗しただけなので、画面に留まって再操作できるようにする
        this.loadError = false
      }
    },
    shopChange () {
      this.sendUserList = []
      this.getSendUserList()
    },
    async getSendUserList () {
      try {
        this.sendUserList = await this.$store.dispatch('MYCARD_SEARCH_USERS_BY_SHOP_ID', { shop_id: this.selectShopId}) || []
      } catch (err) {
        // 一覧が取得できなかった場合も v-for でエラーにならないよう空配列にしておく
        console.error(err)
        this.sendUserList = []
        this.handleLoadError(false)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-send-list.js